<template>
  <div id="app">
      <div class="e-flex pageTop">
          <img class="logoImg" src="@/assets/images/logo.png" />
          <div class="flexAll"></div>
          <el-menu ref="menu" :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect" active-text-color="#008CFF">
              <el-menu-item v-for="(item, indexInt) in menuList" :id="'menuId' + item.id" v-if="indexInt < 2" :index="item.id" :key="item.id">{{ item.name }}</el-menu-item>
              <el-submenu v-for="(item, indexInt) in menuList" v-if="indexInt == 2 || indexInt == 3" :id="'menuId' + item.id" :index="item.id" :key="item.id">
                  <template slot="title">{{ item.name }}</template>
                  <el-menu-item v-for="(val, num) in item.children" :id="'menuId' + item.id + val.id" :index="item.id + '-' + val.id" :key="val.key">{{ val.name }}</el-menu-item>
              </el-submenu>
              <el-menu-item v-for="(item, indexInt) in menuList" v-if="indexInt > 3" :id="'menuId' + item.id" :index="item.id" :key="item.id">{{ item.name }}</el-menu-item>
          </el-menu>
          <div class="loginInfo e-flex" v-if="user">
            <el-dropdown trigger="click">
              <span class="el-dropdown-link e-flex">
                <img class="ic_user" src="@/assets/images/ic_user.png" />
                <div class="phone">{{ user.phone ? (user.phone.slice(0,3) + '****' + user.phone.slice(7,11)) : '' }}</div>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <div class="loginMenuList" @click="goLoginMenu('/activityRegistration/index')">活动报名记录</div>
                </el-dropdown-item>
                <el-dropdown-item>
                  <div class="loginMenuList" @click="goLoginMenu('/appeal/index')">我的诉求</div>
                </el-dropdown-item>
                <el-dropdown-item>
                  <div class="loginMenuList e-flex">
                  <div class="logoutBtn" @click="logout()">退出登录</div>
                </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div v-else class="loginBtn" @click="loginVisible = true" style="cursor: pointer;">登录</div>
      </div>
      <el-dialog title="" :visible.sync="loginVisible" width="12.916666666666666rem" :close-on-click-modal="false">
          <div class="e-flex loginFlex">
            <img class="loginImg" src="@/assets/images/loginImg.png" />
            <div>
              <div class="loginTitle">欢迎登录</div>
              <div class="controlEle e-flex">
                <el-input v-model="loginPhone" placeholder="输入手机号"></el-input>
              </div>
              <div class="controlEle e-flex">
                <el-input v-model="code" placeholder="输入验证码"></el-input>
                <div class="getcodeBtn" @click="getCode()">{{ codeName }}</div>
              </div>
              <div class="loginBtnDialog" @click="login()" style="cursor: pointer;">登录</div>
            </div>
          </div>
          
        </el-dialog>
        <div class="routerContent">
          <router-view @goNavPage="goNavPage($event)" @pageLogin="pageLogin($event)" />
        </div>
    
    <bottom />
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
      return {
        pathId: '1',
        activeIndex: '1',
        menuList: [{
          name: '首页',
          id: '1',
          path: '/index/index'
        },{
          name: '园区动态',
          id: '2',
          path: '/parkDynamics/index'
        },{
          name: '园区介绍',
          id: '3',
          path: '',
          children: [{
            name: '未来科学城介绍',
            id: '1',
            path: '/parkDescription/futureCityDescription',
            key: '31',
            detailPath: []
          },{
            name: '服开区重点园区',
            id: '2',
            path: '/parkDescription/importantPark',
            key: '32',
            detailPath: []
          },{
            name: '昌平自贸组团',
            id: '3',
            path: '/parkDescription/freeTradeAgreement',
            key: '33',
            detailPath: []
          }]
        },{
          name: '两区政策',
          id: '4',
          path: '',
          children: [{
            name: '政策查询',
            id: '1',
            path: '/twoRegionPolicy/twoRegionPolicySearch',
            key: '41',
            detailPath: ['/twoRegionPolicy/regionPolicyDetail']
          },{
            name: '政策解读',
            id: '2',
            path: '/twoRegionPolicy/policyInterpretation',
            key: '42',
            detailPath: ['/twoRegionPolicy/policyInterpretationDetail']
          },{
            name: '通知公告',
            id: '3',
            path: '/twoRegionPolicy/twoRegionPolicyAnnouncement',
            key: '43',
            detailPath: ['/twoRegionPolicy/twoRegionPolicyAnnouncementDetail']
          }]
        },{
          name: '两区活动',
          id: '5',
          path: '/twoRegionActivity/index'
        },{
          name: '政务服务',
          id: '6',
          path: '/governmentAffairsService/index'
        },{
          name: '发展赋能',
          id: '7',
          path: '/developmentEmpowerment/index'
        },{
          name: '创新案例',
          id: '8',
          path: '/innovationCase/index'
        },{
          name: '企业联盟',
          id: '9',
          path: '/unionEnterprises/index'
        }],
        loginVisible: false,
        loginPhone: '',
        code: '',
        initMenu: true,
        user: '',
				codeName: '获取验证码',
				n: 180,
      }
    },
    methods: {
      handleSelect(key, keyPath) {
        if (!this.menuList[parseInt(this.pathId.split('-')[0]) - 1]) {
          this.pathId = key
          return
        }
        let routerPath = this.pathId.split('-').length == 1 ? this.menuList[parseInt(this.pathId.split('-')[0]) - 1].path : this.menuList[parseInt(this.pathId.split('-')[0]) - 1].children[parseInt(this.pathId.split('-')[1]) - 1].path
        if (key == this.pathId && window.location.href.split('#')[1].split('?')[0] == routerPath) { // 同一个页面不跳转，详情页跳转
          return
        }
        this.pathId = key
        let itemData = {}
        let ids = key.split('-')
        if (ids.length == 1) {
          itemData = this.menuList[parseInt(ids[0]) - 1]
        } else {
          itemData = this.menuList[parseInt(ids[0]) - 1].children[parseInt(ids[1]) - 1]
        }
        this.$router.push({ path: itemData.path, query: {}})
      },
      goNavPage(obj) {
        this.pathId = ''
        if (obj.pathId) {
          this.pathId = obj.pathId
        }
        this.activeIndex = obj.key
        if (obj.subMenu) {
          document.getElementById('menuId' + obj.subMenu).click()
          setTimeout(() => {
            document.getElementById('menuId' + obj.key).click()
          }, 300);
        } else {
          document.getElementById('menuId' + obj.key).click()
        }
      },
      onPopState(e) {
        let pagePath = window.location.href.split('#')[1]
        this.menuList.forEach((item, index, array) => {
          if (item.path == pagePath) {
            this.goNavPage({
              key:(index + 1).toString(),
              path: [(index + 1).toString()]
            })
          }
          if (item.children && item.children.length != 0) {
            item.children.forEach((val, num, ar) => {
              if (val.path == pagePath) {
                this.goNavPage({
                  key:item.id + val.id,
                  path: [item.id + val.id],
                  subMenu:item.id
                })
              }
            })
          }
        })
      },
      goLoginMenu(url) {
        this.pathId = ''
        this.$router.push({ path: url, query: {}})
      },
      login() {
        this.request({
            url: 'user/login',
            method: 'POST',
            data: {
              mobile:this.loginPhone,
              code:this.code
            }
        }).then(res => {
          if (res.code == 1) {
            localStorage.setItem('user', JSON.stringify(res.data));
            this.user = res.data
            this.loginVisible = false
          }
        })
      },
      pageLogin() {
        this.user = JSON.parse(localStorage.getItem('user'))
      },
      getCode() {
        if (!this.loginPhone) {
          this.$message({
            message: '请填写手机号',
            type: 'warning',
            iconClass: 'none'
          });
          return
        }
        if (this.codeName != '获取验证码') {
					this.$message({
            message: '请勿重复获取',
            type: 'warning',
            iconClass: 'none'
          });
					return
				}
        this.request({
            url: 'user/getCode',
            method: 'POST',
            data: {
              mobile: this.loginPhone
            }
        }).then(res => {
            if (res.code == 1) {
              this.$message({
                  message: '验证码已发送',
                  type: 'success',
                  iconClass: 'none'
              });
              if (this.n >= 0) {
								this.codeName = this.n + ' s'
								let interval = setInterval(() => {
									if (this.n == 0) {
										this.codeName = '获取验证码'
										this.n = 180
										clearInterval(interval)
										return
									}
									this.n = this.n - 1
									this.codeName = this.n + ' s'
								},1000)
							} else {
								this.codeName = '获取验证码'
							}
            }
        })
      },
      logout() {
        localStorage.setItem('user', '');
        this.user = ''
      }
    },
    created() {
      console.log(JSON.parse(localStorage.getItem('user')))
      this.user = localStorage.getItem('user') ? (JSON.parse(localStorage.getItem('user')).data ? JSON.parse(localStorage.getItem('user')).data : JSON.parse(localStorage.getItem('user'))) : null
      window.addEventListener('popstate',this.onPopState)
      // console.log(this.$route.path)
      if (this.$route.path == '/index/index') {
        return
      }
      if (this.$route.path.length <= 2) {
        this.$router.push({ path: '/index/index', query: {}})
        this.pathId = '1'
      } else {
        this.menuList.forEach((item, index, array) => {
          if (window.location.href.split('#')[1].split('?')[0] == item.path) {
            this.pathId = (index + 1).toString()
            this.activeIndex = (index + 1).toString()
          }
          if (item.children && item.children.length != 0) {
            item.children.forEach((val, num, ar) => {
              if (window.location.href.split('#')[1].split('?')[0] == val.path || val.detailPath.indexOf(window.location.href.split('#')[1].split('?')[0]) != -1) {
                this.pathId = (index + 1).toString() + '-' + (num + 1).toString()
                this.activeIndex = (index + 1).toString() + '-' +  (num + 1).toString()
              }
            })
          }
        })
      }
      // console.log(111,window.location.href.split('#')[1].split('?')[0])
      // this.$router.push({ path: '/index/index', query: {}})
      // this.pathId = '1'
    },
}
</script>

<style>
  
</style>



// WEBPACK FOOTER //
// src/App.vue